import { useEffect, useState, useRef } from 'react';
import keycloakInstance from '../services/KeycloakService';
import { useAppDispatch } from '../store/hooks';
import { setKcObject } from '../store/authentication/auth';
import { setKeycloakInstance } from '../api/apiConfig';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const initialized = useRef(false);
  const dispatch = useAppDispatch();

  // initialising keycloak
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    keycloakInstance
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false
      })
      .then((authenticated) => {
        if (authenticated) {
          setIsAuthenticated(authenticated);
          setKeycloakInstance(keycloakInstance);
          dispatch(setKcObject(keycloakInstance));
        }
      })
      .catch((error: unknown) => {
        console.error('Keycloak initialization failed', error);
      });
  }, [dispatch]);

  return {
    isAuthenticated
  };
};
